// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.freizeitangebote-container {
  margin-bottom: 4rem;
}

.bottom-spacer {
  height: 0.5rem;
}

.offer-category {
  margin-bottom: 20px;
}

.offer-title {
  background-color: var(--mittelblau);
  color: var(--blassgruen);
  font-family: 'Staatliches', sans-serif;
  font-weight: normal;
  text-align: center;
  padding: 10px 15px;
  border-radius: 10px;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: -12px;
  transition: 0.2s ease;
  margin-bottom: 0;
  font-size: 25px;
}

.offer-title.expanded {
  background-color: var(--primary-light);
  color: var(--mittelblau);
  font-family: 'Staatliches', sans-serif;
  border-top: 2px solid var(--mittelblau);
  border-left: 2px solid var(--mittelblau);
  border-right: 2px solid var(--mittelblau);
  border-radius: 10px 10px 0px 0px;
}

.offer-arrow {
  transition: transform 0.3s ease;
  color: var(--blassgruen);
  font-family: 'Material Symbols Outlined';
  font-variation-settings: 'FILL' 0, 'wght' 400, 'GRAD' 0, 'opsz' 40;
  font-size: 40px;
}

.offer-title.expanded .offer-arrow {
  color: var(--mittelblau);
}

.offer-details {
  margin-top: 0;
  background-color: var(--primary-light);
  color: var(--mittelblau);
  line-height: 1.5;
  max-height: 0;
  overflow: hidden;
  transition: 0.3s ease;
}

.offer-details.expanded {
  border-bottom: 2px solid var(--mittelblau);
  border-left: 2px solid var(--mittelblau);
  border-right: 2px solid var(--mittelblau);
  border-radius: 0px 0px 10px 10px;
  padding: 0.5rem 1rem 1rem;
  max-height: 500px;
  background-color: var(--primary-light);
}

.offer-description {
  margin: 0.5rem 0;
  font-family: 'Circular', sans-serif;
  color: var(--mittelblau);
  font-weight: normal;
  text-align: left;
}

.offer-detail-item {
  margin: 0.7rem 0;
  font-family: 'Circular', sans-serif;
  font-weight: normal;
  color: var(--mittelblau);
  display: flex;
  align-items: center;
  gap: 5px;
}

.offer-detail-item .cost-icon {
  color: var(--mittelblau);
  fill: var(--mittelblau);
}

.freizeitangebote-container .location-link {
  display: inline-flex;
  align-items: center;
  gap: 0.3rem;
  margin-top: 0.3rem;
}

.freizeitangebote-container .location-label {
  color: var(--mittelblau);
  text-decoration: underline;
  text-underline-offset: 4px;
  font-family: 'Staatliches', sans-serif;
  font-weight: normal;
  font-size: 1.3rem;
}

.freizeitangebote-container .location-icon {
  color: var(--mittelblau);
  stroke: var(--mittelblau);
  stroke-width: 1.2;
  font-size: 1.3rem;
}

.filter-head {
  display: flex;
  gap: 10px;
  margin-bottom: 10px;
  background-color: var(--blassgruen);
  padding: 5px 10px;
}

.search-wrapper {
  position: relative;
  flex-grow: 1;
  display: flex;
  align-items: center;
}

.search-wrapper::after {
  content: "";
  position: absolute;
  left: 40px;
  right: 10px;
  bottom: 23px;
  height: 2px;
  background-color: var(--dunkelgruen);
}

.search-wrapper input[type="text"] {
  width: 100%;
  padding: 5px 0 5px 40px;
  border: none;
  border-radius: 0;
  outline: none;
  background-color: transparent;
  box-shadow: none;
  color: var(--dunkelgruen);
}

.search-wrapper input[type="text"]::placeholder {
  color: var(--hellgruen);
  font-size: 1.2em;
}

.search-icon {
  position: absolute;
  left: 0;
  top: calc(50% - 8px);
  transform: translateY(-50%);
  pointer-events: none;
  color: var(--dunkelgruen);
  font-family: 'Material Symbols Outlined';
  font-variation-settings: 'FILL' 0, 'wght' 400, 'GRAD' 0, 'opsz' 40;
  font-size: 30px;
}
`, "",{"version":3,"sources":["webpack://./src/components/freizeit/freizeitangebote/Freizeitangebote.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;EACnC,wBAAwB;EACxB,sCAAsC;EACtC,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,sCAAsC;EACtC,wBAAwB;EACxB,sCAAsC;EACtC,uCAAuC;EACvC,wCAAwC;EACxC,yCAAyC;EACzC,gCAAgC;AAClC;;AAEA;EACE,+BAA+B;EAC/B,wBAAwB;EACxB,wCAAwC;EACxC,kEAAkE;EAClE,eAAe;AACjB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,sCAAsC;EACtC,wBAAwB;EACxB,gBAAgB;EAChB,aAAa;EACb,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,0CAA0C;EAC1C,wCAAwC;EACxC,yCAAyC;EACzC,gCAAgC;EAChC,yBAAyB;EACzB,iBAAiB;EACjB,sCAAsC;AACxC;;AAEA;EACE,gBAAgB;EAChB,mCAAmC;EACnC,wBAAwB;EACxB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,mCAAmC;EACnC,mBAAmB;EACnB,wBAAwB;EACxB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,wBAAwB;EACxB,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,0BAA0B;EAC1B,0BAA0B;EAC1B,sCAAsC;EACtC,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,wBAAwB;EACxB,yBAAyB;EACzB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,mCAAmC;EACnC,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,WAAW;EACX,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,6BAA6B;EAC7B,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,oBAAoB;EACpB,2BAA2B;EAC3B,oBAAoB;EACpB,yBAAyB;EACzB,wCAAwC;EACxC,kEAAkE;EAClE,eAAe;AACjB","sourcesContent":[".freizeitangebote-container {\n  margin-bottom: 4rem;\n}\n\n.bottom-spacer {\n  height: 0.5rem;\n}\n\n.offer-category {\n  margin-bottom: 20px;\n}\n\n.offer-title {\n  background-color: var(--mittelblau);\n  color: var(--blassgruen);\n  font-family: 'Staatliches', sans-serif;\n  font-weight: normal;\n  text-align: center;\n  padding: 10px 15px;\n  border-radius: 10px;\n  cursor: pointer;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-top: -12px;\n  transition: 0.2s ease;\n  margin-bottom: 0;\n  font-size: 25px;\n}\n\n.offer-title.expanded {\n  background-color: var(--primary-light);\n  color: var(--mittelblau);\n  font-family: 'Staatliches', sans-serif;\n  border-top: 2px solid var(--mittelblau);\n  border-left: 2px solid var(--mittelblau);\n  border-right: 2px solid var(--mittelblau);\n  border-radius: 10px 10px 0px 0px;\n}\n\n.offer-arrow {\n  transition: transform 0.3s ease;\n  color: var(--blassgruen);\n  font-family: 'Material Symbols Outlined';\n  font-variation-settings: 'FILL' 0, 'wght' 400, 'GRAD' 0, 'opsz' 40;\n  font-size: 40px;\n}\n\n.offer-title.expanded .offer-arrow {\n  color: var(--mittelblau);\n}\n\n.offer-details {\n  margin-top: 0;\n  background-color: var(--primary-light);\n  color: var(--mittelblau);\n  line-height: 1.5;\n  max-height: 0;\n  overflow: hidden;\n  transition: 0.3s ease;\n}\n\n.offer-details.expanded {\n  border-bottom: 2px solid var(--mittelblau);\n  border-left: 2px solid var(--mittelblau);\n  border-right: 2px solid var(--mittelblau);\n  border-radius: 0px 0px 10px 10px;\n  padding: 0.5rem 1rem 1rem;\n  max-height: 500px;\n  background-color: var(--primary-light);\n}\n\n.offer-description {\n  margin: 0.5rem 0;\n  font-family: 'Circular', sans-serif;\n  color: var(--mittelblau);\n  font-weight: normal;\n  text-align: left;\n}\n\n.offer-detail-item {\n  margin: 0.7rem 0;\n  font-family: 'Circular', sans-serif;\n  font-weight: normal;\n  color: var(--mittelblau);\n  display: flex;\n  align-items: center;\n  gap: 5px;\n}\n\n.offer-detail-item .cost-icon {\n  color: var(--mittelblau);\n  fill: var(--mittelblau);\n}\n\n.freizeitangebote-container .location-link {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.3rem;\n  margin-top: 0.3rem;\n}\n\n.freizeitangebote-container .location-label {\n  color: var(--mittelblau);\n  text-decoration: underline;\n  text-underline-offset: 4px;\n  font-family: 'Staatliches', sans-serif;\n  font-weight: normal;\n  font-size: 1.3rem;\n}\n\n.freizeitangebote-container .location-icon {\n  color: var(--mittelblau);\n  stroke: var(--mittelblau);\n  stroke-width: 1.2;\n  font-size: 1.3rem;\n}\n\n.filter-head {\n  display: flex;\n  gap: 10px;\n  margin-bottom: 10px;\n  background-color: var(--blassgruen);\n  padding: 5px 10px;\n}\n\n.search-wrapper {\n  position: relative;\n  flex-grow: 1;\n  display: flex;\n  align-items: center;\n}\n\n.search-wrapper::after {\n  content: \"\";\n  position: absolute;\n  left: 40px;\n  right: 10px;\n  bottom: 23px;\n  height: 2px;\n  background-color: var(--dunkelgruen);\n}\n\n.search-wrapper input[type=\"text\"] {\n  width: 100%;\n  padding: 5px 0 5px 40px;\n  border: none;\n  border-radius: 0;\n  outline: none;\n  background-color: transparent;\n  box-shadow: none;\n  color: var(--dunkelgruen);\n}\n\n.search-wrapper input[type=\"text\"]::placeholder {\n  color: var(--hellgruen);\n  font-size: 1.2em;\n}\n\n.search-icon {\n  position: absolute;\n  left: 0;\n  top: calc(50% - 8px);\n  transform: translateY(-50%);\n  pointer-events: none;\n  color: var(--dunkelgruen);\n  font-family: 'Material Symbols Outlined';\n  font-variation-settings: 'FILL' 0, 'wght' 400, 'GRAD' 0, 'opsz' 40;\n  font-size: 30px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
